import { render, staticRenderFns } from "./send-welcome-email-modal.vue?vue&type=template&id=2d5df28f&"
import script from "./send-welcome-email-modal.vue?vue&type=script&lang=js&"
export * from "./send-welcome-email-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports